module.exports = __webpack_public_path__ + "static/media/e50b205a-ada1-4029-b4d0-f3369d8681d5.127c6d56.JPG";